import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

export const removeFromCart = (params = {}, pathParams: PathParams) =>
    axios.delete(`${API_URLS.CART}remove/${pathParams.id}`, { ...params });
